export const odluka_o_placenom_dopustu = {
    templateId: 29,
    category: 3,
    templateTitle: 'Odluka o plaćenom dopustu',
    templateDescription: `<p>Tijekom kalendarske godine, a najčešće iz razloga sklapanja braka, rođenja djeteta, teže bolesti, smrti člana uže obitelji (navedeno su razlozi propisano Zakonom o radu) odnosno drugih razloga određenih kolektivnim ugovorom, pravilnikom o radu odnosno ugovorom o radu, radnik ima pravo od poslodavca zatražiti korištenje plaćenog dopusta.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Tijekom kalendarske godine radnik ima pravo na oslobođenje od obveze rada uz naknadu plaće​ (plaćeni dopust) za važne osobne potrebe, a osobito u vezi sa:</p>
    <li>- sklapanjem braka,</li>
    <li>- rođenjem djeteta,</li>
    <li>- težom bolesti,</li>
    <li>- smrću člana uže ​obitelji.</li>
    <p>Za stjecanje prava iz radnog odnosa ili u vezi s radnim odnosom, razdoblja plaćenog dopusta smatraju se vremenom provedenim na radu.</p>
    <p><strong>Poslodavac kod kojega pitanje plaćenog dopusta nije regulirano ugovorom o radu, pravilnikom o radu ili kod kojega se ne primjenjuje kolektivni ugovor, slobodno određuje koliko će dana plaćenog dopusta odobriti za pojedinu potrebu radnika.</strong></p>
    <p><strong>Poslodavac odlučuje o plaćenom dopustu na temelju zahtjeva radnika.</strong></p>
    <p>Dakle, teoretski gledano, radnik bi npr. za sklapanje braka ili smrt roditelja prema zakonu o radu mogao imati pravo i na samo jedan dan, no i na sedam dana.</p>
    <p>Radnik ima pravo na gore spomenute dopuste u ukupnom trajanju od <strong>sedam radnih dana godišnje​</strong>, ako to nije drukčije uređeno kolektivnim ugovorom, pravilnikom o radu ili ugovorom o radu.</p>
    <p>Kolektivnim ugovorom, pravilnikom radu ili ugovorom o radu mogu se odrediti i druge osnove (potrebe) za plaćeni dopust.</p>
    <p>Plaćeni dopust posebna je kategorija, koja se samostalno ostvaruje i nije vezana uz godišnji odmor, bolovanje i druga opravdana odsustva s rada.</p>
    <p>Članom uže obitelji smatraju se: supružnik, srodnici po krvi u pravoj liniji i njihovi supružnici, braća i sestre, pastorčad i posvojenici, djeca povjerena na čuvanje i odgoj ili djeca na skrbi izvan vlastite obitelji, očuh i maćeha, posvojitelj i osoba koju je radnik dužan po zakonu uzdržavati, te osoba koja s radnikom živi u izvanbračnoj zajednici.</p>
    <p>Radnik ima pravo na plaćeni dopust za vrijeme obrazovanja ili stručnog osposobljavanja i usavršavanja te obrazovanja za potrebe radničkog vijeća ili sindikalnog rada, pod uvjetima, u trajanju i uz naknadu određenu kolektivnim ugovorom, sporazumom sklopljenim između radničkog vijeća i poslodavca ili pravilnikom o radu.</p>
    <p>Radnik po osnovi darivanja krvi, ostvaruje pravo na jedan plaćeni slobodan dan, koji koristi na dan darivanja krvi, osim ako kolektivnim ugovorom, sporazumom sklopljenim između radničkog vijeća i poslodavca ili ugovorom o radu nije drukčije uređeno.</p>
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Netočno evidentiranje plaćenog dopusta u evidenciji radnog vremena</strong></p>
    <p>Pojašnjenje: sukladno Pravilniku o sadržaju i načinu vođenja evidencije o radnicima plaćeni dopust se evidentira kao vrijeme nenazočnosti na radu.</p>
    <h5>PRAVNA OSNOVA</h5>
    <p> Zakon o radu.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o radu,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: '(u daljnjem tekstu: Poslodavac),',
        }
    ],

    headline: 'donosi sljedeću',
    title: 'ODLUKU O PLAĆENOM DOPUSTU',
    noArticleNumbers: true,
    
    articles: [
      {
          mandatory: true,
          statements: [
              {
                  title: '',
                  type: 'input',
                  mandatory: true,
                  editable: true,
                  parts: [
                      {type: 'text', content: 'Radniku'},
                      { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                      { type: "text", content: "," },
                      { type: 'text', content: 'iz',},
                      { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                      { type: 'text', content: ',' },
                      { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                      { type: "text", content: "," },
                      { type: 'text', content: 'OIB:' },
                      {type: 'input', value: '', required: true}
                  ],
              },
              {
                  type: 'input',
                  mandatory: true,
                  editable: false,
                  parts: [
                      {type: 'text', content: '(u daljnjem tekstu: Radnik), odobrava se plaćeni dopust radi'},
                      {type: 'input', value: '', required: true, help: 'Navesti osnovu zbog koje se plaćeni dopust odobrava (sklapanje braka, rođenje djeteta, teža bolest, smrt člana uže obitelji).'},
                      {type: 'text', content: ' u trajanju od'},
                      {type: 'input', value: '', required: true},
                      {type: 'text', content: 'dana, u periodu od'},
                      {type: 'input', value: '', required: true},
                      {type: 'text', content: 'do'},
                      {type: 'input', value: '', required: true},

                  ],
                  value: '',
              },
          ],
      },
        {
            mandatory: true,
            statements: [
                {
                    title: '',
                    type: 'text',
                    mandatory: true,
                    editable: false,
                    content: 'Razdoblje plaćenog dopusta smatra se vremenom provedenim na radu.',
                    value: '',
                }],
        },
        {
            mandatory: true,
            statements: [
                {
                    title: '',
                    type: 'text',
                    mandatory: true,
                    editable: false,
                    content: 'Za vrijeme plaćenog dopusta Radnik ima pravo na naknadu plaće u visini prosječne plaće Radnika ostvarene u tri mjeseca prije korištenja plaćenog dopusta.',
                    value: '',
                }],
        },
        {
          title: '------------------------------------------------------Obrazloženje------------------------------------------------------',
          mandatory: true,
            dummy: true,
            statements: [
                {

                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {type: 'text', content: 'Radnik je dana'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: ' godine, podnio Poslodavcu pisani zahtjev za odobravanjem plaćenog dopusta u trajanju od'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'dana radi'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: '.'},
                    ],
                    value: '',
                }, 
                {
                    type: "text",
                    mandatory: true,
                    editable: false,
                    content: "Poslodavac je razmotrio zahtjev Radnika te je utvrdio da je isti ispunjava sve propisane uvjete, stoga je odlučeno kao u izreci ove Odluke.",
                  },
            ],
        },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
          },
          {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
              {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska služba',
                help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
              }
            ]
          },
          {
            static: true,
            mandatory: true,
            type: 4, 
            statements: [
              {
                type: 'text',
                mandatory: true,
                editable: true,
                help: 'Ako postupak dostave nije uređen kol. ug., sporazumom između radničkog vijeća i poslodavca ili pravilnikom o radu, primjenjuju se odredbe o dostavi određene parničnim postupkom. U tom slučaju, otkaz se može dostaviti prep. pošt. pošiljkom s povr. ili osobno, na radnom mjestu, no ukoliko radnik odbija primiti odluku, navedeno odbijanje može se pisano konstatirati uz potpis dva svjedoka. Otkaz se može dostaviti i putem j. bilježnika.',
                content: 'Potvrđujem primitak Odluke dana _______________ godine.\r\n\r\nPotpis Radnika: ____________________\r\n\r\n',
              },
            ]
          },
        ],
      };


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/29_odluka_o_placenom_dopustu.ts